import { inject } from './inject';
import { Storage } from '@ionic/storage';

const get = async (key: string, prefix?: string): Promise<any> => {
  const appKey = 'br3_paciente';
  if (prefix) key = `${appKey}:${prefix}:${key}`;
  else key = `${appKey}:${key}`;
  const s: Storage = await inject(Storage);
  return s.get(key);
};

const set = async (key: string, value: any, prefix?: string): Promise<any> => {
  const appKey = 'br3_paciente';
  if (prefix) key = `${appKey}:${prefix}:${key}`;
  else key = `${appKey}:${key}`;
  const s: Storage = await inject(Storage);
  return s.set(key, value);
};

const storage = {
  get, set
};

export { storage };
window['storage'] = storage;
